// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * WE2 P4-04: Timeframe footer styles.
 */

.vnsc-timeframe-footer {
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 4px 12px;
	background: var(--vnsc-bg-secondary);
	border-top: 1px solid var(--vnsc-border);
	z-index: 30;
	flex-wrap: wrap;
}

.vnsc-tf-chip,
.vnsc-range-chip {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	padding: 3px 8px;
	border: 1px solid transparent;
	border-radius: var(--vnsc-radius-md);
	cursor: pointer;
	font-size: var(--vnsc-font-sm);
	font-weight: 500;
	background: transparent;
	color: var(--vnsc-text-secondary);
	transition: color var(--vnsc-transition-fast), border-color var(--vnsc-transition-fast);
	font-family: inherit;
}

.vnsc-tf-chip:hover,
.vnsc-range-chip:hover {
	color: var(--vnsc-text-primary);
	border-color: rgba(255, 255, 255, 0.12);
}

.vnsc-tf-chip--active,
.vnsc-range-chip--active {
	color: var(--vnsc-text-primary);
	font-weight: 600;
	border-color: rgba(255, 255, 255, 0.18);
}

.vnsc-tf-chip--active:hover,
.vnsc-range-chip--active:hover {
	border-color: rgba(255, 255, 255, 0.25);
}

/* Trademark in footer */
.vnsc-trademark {
	display: flex;
	align-items: center;
	gap: 4px;
	padding: 0 8px;
	font-size: 11px;
	font-weight: 500;
	color: rgba(255, 255, 255, 0.35);
	cursor: pointer;
	user-select: none;
	white-space: nowrap;
	margin-left: auto;
}

.vnsc-trademark:hover {
	color: rgba(255, 255, 255, 0.5);
}

.vnsc-trademark-icon {
	font-size: 11px;
	color: rgba(99, 102, 241, 0.5);
}

.vnsc-trademark-icon:hover {
	color: rgba(99, 102, 241, 0.7);
}
`, "",{"version":3,"sources":["webpack://./src/widget/styles/footer.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;CACC,aAAa;CACb,mBAAmB;CACnB,SAAS;CACT,iBAAiB;CACjB,oCAAoC;CACpC,wCAAwC;CACxC,WAAW;CACX,eAAe;AAChB;;AAEA;;CAEC,oBAAoB;CACpB,mBAAmB;CACnB,uBAAuB;CACvB,gBAAgB;CAChB,6BAA6B;CAC7B,oCAAoC;CACpC,eAAe;CACf,8BAA8B;CAC9B,gBAAgB;CAChB,uBAAuB;CACvB,iCAAiC;CACjC,uFAAuF;CACvF,oBAAoB;AACrB;;AAEA;;CAEC,+BAA+B;CAC/B,uCAAuC;AACxC;;AAEA;;CAEC,+BAA+B;CAC/B,gBAAgB;CAChB,uCAAuC;AACxC;;AAEA;;CAEC,uCAAuC;AACxC;;AAEA,wBAAwB;AACxB;CACC,aAAa;CACb,mBAAmB;CACnB,QAAQ;CACR,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,gCAAgC;CAChC,eAAe;CACf,iBAAiB;CACjB,mBAAmB;CACnB,iBAAiB;AAClB;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,eAAe;CACf,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B","sourcesContent":["/**\r\n * WE2 P4-04: Timeframe footer styles.\r\n */\r\n\r\n.vnsc-timeframe-footer {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tgap: 12px;\r\n\tpadding: 4px 12px;\r\n\tbackground: var(--vnsc-bg-secondary);\r\n\tborder-top: 1px solid var(--vnsc-border);\r\n\tz-index: 30;\r\n\tflex-wrap: wrap;\r\n}\r\n\r\n.vnsc-tf-chip,\r\n.vnsc-range-chip {\r\n\tdisplay: inline-flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\tpadding: 3px 8px;\r\n\tborder: 1px solid transparent;\r\n\tborder-radius: var(--vnsc-radius-md);\r\n\tcursor: pointer;\r\n\tfont-size: var(--vnsc-font-sm);\r\n\tfont-weight: 500;\r\n\tbackground: transparent;\r\n\tcolor: var(--vnsc-text-secondary);\r\n\ttransition: color var(--vnsc-transition-fast), border-color var(--vnsc-transition-fast);\r\n\tfont-family: inherit;\r\n}\r\n\r\n.vnsc-tf-chip:hover,\r\n.vnsc-range-chip:hover {\r\n\tcolor: var(--vnsc-text-primary);\r\n\tborder-color: rgba(255, 255, 255, 0.12);\r\n}\r\n\r\n.vnsc-tf-chip--active,\r\n.vnsc-range-chip--active {\r\n\tcolor: var(--vnsc-text-primary);\r\n\tfont-weight: 600;\r\n\tborder-color: rgba(255, 255, 255, 0.18);\r\n}\r\n\r\n.vnsc-tf-chip--active:hover,\r\n.vnsc-range-chip--active:hover {\r\n\tborder-color: rgba(255, 255, 255, 0.25);\r\n}\r\n\r\n/* Trademark in footer */\r\n.vnsc-trademark {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tgap: 4px;\r\n\tpadding: 0 8px;\r\n\tfont-size: 11px;\r\n\tfont-weight: 500;\r\n\tcolor: rgba(255, 255, 255, 0.35);\r\n\tcursor: pointer;\r\n\tuser-select: none;\r\n\twhite-space: nowrap;\r\n\tmargin-left: auto;\r\n}\r\n\r\n.vnsc-trademark:hover {\r\n\tcolor: rgba(255, 255, 255, 0.5);\r\n}\r\n\r\n.vnsc-trademark-icon {\r\n\tfont-size: 11px;\r\n\tcolor: rgba(99, 102, 241, 0.5);\r\n}\r\n\r\n.vnsc-trademark-icon:hover {\r\n\tcolor: rgba(99, 102, 241, 0.7);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
